"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var formatDateForLocale = function formatDateForLocale(timestamp, locale) {
  var defaultLocale = typeof window !== 'undefined' ? (0, _globals.default)('communityLanguage') || 'en-US' : 'en-US';
  var date = new Date(timestamp);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid timestamp provided');
  }

  var options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };
  return date.toLocaleString(locale !== null && locale !== void 0 ? locale : defaultLocale, options);
};

var _default = formatDateForLocale;
exports.default = _default;